<p *ngIf="!isStorePublished" class="text-sm text-gray-500 mt-2 px-4">
    This store is not yet accepting orders.
</p>
<div *ngIf="isMobile">
    <hr>
    <div class="flex justify-between items-center ml-4 py-2 height-[56px]">
      <div>
        <ng-container *ngIf="(selectedVariantMSRP && discountPercentage); else normalPrice">
          <div class="flex flex-row items-center">
            <ng-container *ngIf="mobileBuyBannerType === 'regular'">
              <p class="mrsp-price text-gray-300 line-through mx-1 mr-2">
                <span class="currency-tag">{{ (selectedVariantMSRP | separatedFormatPrice)?.currency }}</span>
                <span class="price-number">{{ (selectedVariantMSRP | separatedFormatPrice)?.price }}</span>
              </p>
            </ng-container>
            <div>
              <span class="save-label whitespace-nowrap mr-2">
                -{{ discountPercentage | number:'1.0-0' }}%
              </span>
            </div>
            <div>
              <p class="font-[#2E3742]">
                <span class="currency-tag">{{ (totalDisplayPrice | separatedFormatPrice)?.currency }}</span>
                <span class="price-number">{{ (totalDisplayPrice | separatedFormatPrice)?.price }}</span>
              </p>
            </div>
          </div>
        </ng-container>
        <ng-template #normalPrice>
          <p class="font-[#2E3742]">
            <span class="currency-tag">{{ (totalDisplayPrice | separatedFormatPrice)?.currency }}</span>
            <span class="price-number">{{ (totalDisplayPrice | separatedFormatPrice)?.price }}</span>
          </p>
        </ng-template>
      </div>
      <div class="mr-2">
        <button type="submit" class="btn btn-primary max-w-xs flex-1 border border-transparent rounded-md py-2 px-6 flex items-center justify-center w-full whitespace-nowrap"
            [disabled]="isAddToCartDisabled()"
            (click)="addToCartAndOpenDrawer()"
        >
          <div>{{buttonText}}</div>
        </button>
      </div>
    </div>
</div>
<div *ngIf="(isMobile===false)">
    <div class="flex align-baseline height-[54px]">
        <button
            type="submit"
            class="btn btn-primary w-100 flex-1 border border-transparent rounded-md py-3 px-8 flex items-center justify-center
                focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-primary-500"
            [disabled]="isAddToCartDisabled()"
            (click)="addToCartAndOpenDrawer()"
        >
            <div class="text-[20px]">{{buttonText}}</div>
        </button>
    </div>
</div>
